export default __webpack_public_path__ + "static/im_hero-311db894ea2ae2289ca19283d8e23c82.png";